import type { IconData } from '@stacksjs/iconify-core'

export const union: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M10.858 2.48L10 2.888l-.858-.408a5 5 0 1 0 0 9.04l.858-.408l.858.408a5 5 0 1 0 0-9.04M13 0a7 7 0 1 1-3 13.326A7 7 0 1 1 10 .673A7 7 0 0 1 13 0\"/>",
  "width": 20,
  "height": 14,
  "viewBox": "0 0 20 14"
}

export default union
